<template>
  <div>
    <a-row>
      <a-col :span="2"></a-col>
      <a-col :span="6">时间</a-col>
      <a-col :span="14">
        <a-select v-model="data.type" style="width: 100%;" size="small" @change="changDuration">
          <a-select-option :value="0">今天</a-select-option>
          <a-select-option :value="1">本周</a-select-option>
          <a-select-option :value="2">本月</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
    <a-row>
      <a-col :span="2"></a-col>
      <a-col :span="6">设备</a-col>
      <a-col :span="14">
        <a-select v-model="data.deviceId" style="width: 100%;" size="small" @change="changDeviceId">
          <a-select-option :key="device.id" v-for="device in devices" :value="device.id">{{ device.name }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
    <a-row>
      <a-col :span="2"></a-col>
      <a-col :span="6">数据点</a-col>
      <a-col :span="14">
        <a-select v-model="data.pointCode" style="width: 100%;" size="small" @focus="getPoints" @change="changPointCode">
          <a-select-option :key="point.code" v-for="point in options.points" :value="point.code">{{ `${point.name} ${point.unit}` }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
    <a-row>
      <a-col :span="2"></a-col>
      <a-col :span="6">聚合方式</a-col>
      <a-col :span="14">
        <a-select v-model="data.aggregationType" style="width: 100%;" size="small" @change="changStatsType">
          <a-select-option value="SUM">累计值</a-select-option>
          <a-select-option value="AVG">平均值</a-select-option>
          <a-select-option value="MAX">最大值</a-select-option>
          <a-select-option value="MIN">最小值</a-select-option>
          <a-select-option value="DIFF">差值</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
  </div>
</template>

<script>
import { getProtocol } from '@/api/protocol'

export default {
  name: 'StatsDataPanel',
  props: {
    currentItem: {
      type: Object
    },
    devices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    data() {
      if (this.currentItem && this.currentItem.getAttr('data')) {
        const data = this.currentItem.getAttr('data')
        this.getPoints(data)
        return data
      } else {
        return {
          type: 0,
          deviceId: 0,
          pointCode: '',
          aggregationType: ''
        }
      }
    }
  },
  // mounted () {
  //   console.log(this.data);
  //   this.stats = this.data
  //   if (this.stats.deviceId > 0) {
  //     const device = this.devices.find(device => device.id === this.stats.deviceId)
  //     protocolApi.get(device.driverType, device.protocolCode).then(({ data: { dataPoints } }) => {
  //       this.options.points = dataPoints
  //     })
  //   }
  // },
  data () {
    return {
      options: {
        durations: [],
        devices: [],
        points: []
      },
      stats: {
        type: 0,
        deviceId: 0,
        pointCode: '',
        aggregationType: ''
      }
    }
  },
  methods: {
    getPoints (stats) {
      if (stats?.deviceId > 0) {
        const device = this.devices.find(device => device.id === stats.deviceId)
        getProtocol(device.protocolCode).then(({ data: { points } }) => {
          this.options.points = points.filter(d => d.dataWrite !== 2)
        })
      }
    },
    changDuration (value) {
      this.stats.type = value
      this.emitChange()
    },
    changDeviceId (value) {
      this.stats.deviceId = value
      const device = this.devices.find(device => device.id === value)
      getProtocol(device.protocolCode).then(({ data: { points } }) => {
        this.options.points = points.filter(d => d.dataWrite !== 2)
      })
      this.emitChange()
    },
    changPointCode (value) {
      this.stats.pointCode = value
      this.emitChange()
    },
    changStatsType (value) {
      this.stats.aggregationType = value
      this.emitChange()
    },
    emitChange () {
      this.$emit('change', this.stats)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>
